module.exports = __webpack_public_path__ + "static/media/picture4.8183aec0.jpg";